import React, { Component } from "react";
import { Form, Input, Alert, message, Select } from "antd";
import { withRouter } from "react-router-dom";
import _ from "lodash";

import { LayoutPage, Button, Modal, CreateAccountForm } from "../components";
import { fetchApi } from "../utils";
import { getProfileAction } from "../actions/page/auth";
import { withRedux } from "../hoc";

const { Option } = Select;

const actionToProps = { getProfileAction };

const mapStateToProps = (state) => {
  return {
    t: _.get(state, "t"),
    language: _.get(state, "language"),
  };
};

@withRedux(mapStateToProps, actionToProps)
@withRouter
@Form.create()
class AgentLoginFirstTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
      message: null,
      profileId: null,
      isLoading: false,
      paymentList: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  init = () => {
    this.fetchPaymentList();
  };

  fetchPaymentList = async () => {
    const result = await fetchApi(`booking/payment/list`);
    const data = _.get(result, "data");
    this.setState({ paymentList: data });
  };

  handleSuccess = async (token) => {
    window.localStorage.setItem("token", token);

    const result = await this.props.actions.getProfileAction();
    if (_.get(result, "status") !== "success") {
      message.error(_.get(result, "message"));
      return;
    }

    this.setState({ isOpenModal: false });
    message.success("Success!");
    this.props.history.push("/booking");
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({
          isLoading: true,
        });

        let isOpenModal = false;
        let message = null;
        let profileId = null;

        const dataPost = {
          CTNo: _.get(values, "CTNo"),
          AgentNo: _.get(values, "AgentNo"),
          PYID: _.toNumber(_.get(values, "PYID")),
        };

        const result = await fetchApi(
          "booking/agent/verify",
          "POST",
          JSON.stringify(dataPost)
        );

        if (_.get(result, "status") === "success") {
          isOpenModal = true;
          profileId = _.get(result, "data.key");
        } else {
          message = _.get(result, "message");
        }

        this.setState({
          isOpenModal,
          message,
          profileId,
          isLoading: false,
        });
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { t } = this.props;
    const {
      isOpenModal,
      message,
      profileId,
      isLoading,
      paymentList,
    } = this.state;
    
    return (
      <div className="agent-page">
        <LayoutPage
          pageName="BOX OFFICE"
          image={`${process.env.PUBLIC_URL}/assets/images/boxoffice-banner.jpg`}
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <h2>{t("Agent information")}</h2>
            </div>
            <div className="col-lg-7">
              <div className="block">
                {!_.isEmpty(message) && (
                  <Alert
                    message={message}
                    type="error"
                    showIcon
                    style={{ marginBottom: 20 }}
                  />
                )}
                <Form onSubmit={this.handleSubmit}>
                  <Form.Item label={t("CTNo")}>
                    {getFieldDecorator("CTNo", {
                      rules: [
                        {
                          required: true,
                          message: "Please input CTNo",
                        },
                      ],
                    })(<Input placeholder="เลขที่สัญญาจากทาง Tiffany’s" />)}
                  </Form.Item>
                  <Form.Item label={t("AgentNo")}>
                    {getFieldDecorator("AgentNo", {
                      rules: [
                        {
                          required: true,
                          message: "Please input AgentNo",
                        },
                      ],
                    })(<Input placeholder="หมายเลขเอเจนท์จากทาง Tiffany’s" />)}
                  </Form.Item>
                  <Form.Item label={t("PYID")}>
                    {getFieldDecorator("PYID", {
                      rules: [
                        {
                          required: true,
                          message: "Please input PYID",
                        },
                      ],
                    })(
                      <Select placeholder="ประเภทการชำระเงิน" allowClear>
                        {_.map(paymentList, (payment, index) => {
                          const value = _.get(payment, "pyid");
                          const label = _.get(payment, "pyName");
                          return <Option key={index} value={value}>{label}</Option>;
                        })}
                      </Select>
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Button
                      className="button-login"
                      loading={isLoading}
                      type="primary"
                      htmlType="submit"
                    >
                      {t('Verify code')}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <Modal
          className="create-account-block-modal"
          width={700}
          centered
          visible={isOpenModal}
          onCancel={() => this.setState({ isOpenModal: false })}
        >
          <div className="create-account-block">
            <div className="row">
              <div className="col-md-5" style={{ marginBottom: 20 }}>
                <h2>{t('Create Account')}</h2>
              </div>
              <div className="col-md-7">
                <CreateAccountForm
                  profileId={profileId}
                  onSuccess={this.handleSuccess}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default AgentLoginFirstTime;



// WEBPACK FOOTER //
// ./src/pages/AgentLoginFirstTime.js